/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5c-.9575 0-1.8839-.128-2.7636-.3673a.75.75 0 0 0-.3938 1.4474A12.0147 12.0147 0 0 0 12 24c6.6274 0 12-5.3726 12-12S18.6274 0 12 0 0 5.3726 0 12c0 1.0917.146 2.1505.42 3.1574a.75.75 0 1 0 1.4474-.3938A10.513 10.513 0 0 1 1.4999 12Z"
    />
    <path
      fill="currentColor"
      d="M14.7975 5.21c-2.5519-1.008-5.5706-.4806-7.635 1.5838C5.02 8.9363 4.533 12.1067 5.7 14.7165l-4.4563 4.4563c-.9895.9895-.9895 2.594 0 3.5835.9896.9896 2.594.9896 3.5836 0l4.4562-4.4562c2.6099 1.167 5.7803.6799 7.9228-1.4626 2.0644-2.0644 2.5918-5.0832 1.5837-7.635-.0907-.2298-.3092-.3338-.4969-.353-.1875-.0194-.4117.0367-.559.2089-.3253.3803-.7592.8433-.8814.9655l-3.23 3.23c-.7943.7943-2.0822.7943-2.8765 0-.7943-.7943-.7943-2.0822 0-2.8765l3.23-3.23c.1222-.1222.5852-.5561.9655-.8814.1722-.1473.2283-.3715.209-.559-.0194-.1877-.1233-.4062-.3531-.497Z"
    />
  </React.Fragment>,
  'MenuSubAPIManagementFilled'
);
